// Old intake URLs and where they land now. The intake register replaced My
// Requests, the read-only intake review pages and the Approvals item page
// (2026-10-21); links to them were sent in emails and Teams cards, so they
// redirect permanently. App.js turns each entry into a route; `to` gets the
// route params and returns the new URL.
export const LEGACY_REDIRECTS = [
  { path: '/my-requests', to: () => '/intake-requests?tab=mine' },
  { path: '/intake-review', to: () => '/intake-requests' },
  { path: '/intake-review/:itemId', to: ({ itemId }) => `/intake-requests/${encodeURIComponent(itemId)}` },
  // Approvals is internal; InternalOnly sends scoped roles home first.
  { path: '/approvals/:itemId', to: ({ itemId }) => `/approvals?item=${encodeURIComponent(itemId)}`, internal: true },
];
